import { render, staticRenderFns } from "./SectionFilter.vue?vue&type=template&id=c8feb790"
import script from "./SectionFilter.vue?vue&type=script&lang=js"
export * from "./SectionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports